import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
export const ProductReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const products = [{
    id: 1,
    name: 'BioBalance Pro Prebiotic',
    rating: 4.5,
    review: 'High-quality prebiotic with scientifically validated strains. Our testing confirmed label accuracy and good survivability.',
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Prebiotics'
  }, {
    id: 2,
    name: 'MicrobiomePlus Daily',
    rating: 3.5,
    review: 'Contains beneficial strains but our testing showed lower CFU counts than claimed on packaging.',
    image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Probiotics'
  }, {
    id: 3,
    name: 'GutHealth Digestive Enzymes',
    rating: 4,
    review: 'Effective enzyme blend with good stability. Our tests confirmed activity levels match label claims.',
    image: 'https://images.unsplash.com/photo-1550572017-edd951b55104?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Digestive Support'
  }, {
    id: 4,
    name: 'BiomeScan Home Test Kit',
    rating: 2.5,
    review: 'Limited accuracy compared to clinical testing. Results showed significant inconsistencies in repeat samples.',
    image: 'https://images.unsplash.com/photo-1576671414121-aa0c81c869e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Testing Kits'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % products.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + products.length) % products.length);
  };
  const renderStars = rating => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarIcon key={`full-${i}`} size={18} className="fill-yellow-400 text-yellow-400" data-id="element-1332" data-mp="39e67my8ul7xt" />);
    }
    if (hasHalfStar) {
      stars.push(<div key="half" className="relative" data-id="element-1333" data-mp="2znut6hrjfgco">
          <StarIcon size={18} className="text-gray-300" data-id="element-1334" data-mp="2zmjo8emcw2jz" />
          <div className="absolute top-0 left-0 w-1/2 overflow-hidden" data-id="element-1335" data-mp="2up1oneu8azon">
            <StarIcon size={18} className="fill-yellow-400 text-yellow-400" data-id="element-1336" data-mp="3s5gv15fd72ky" />
          </div>
        </div>);
    }
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarIcon key={`empty-${i}`} size={18} className="text-gray-300" data-id="element-1337" data-mp="3voxr68nj86yb" />);
    }
    return stars;
  };
  return <section id="reviews" className="py-16 bg-white" data-id="element-1338" data-mp="3l5bzhbwves7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1339" data-mp="8hdpkqagmzx9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-1340" data-mp="dh8eioaodffo">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-1341" data-mp="r9g681n3qg7i">
            Product Reviews
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1342" data-mp="wa3tcc87mcwg">
            Independent testing and evaluation of microbiome-related products
          </p>
        </motion.div>
        <div className="relative" data-id="element-1343" data-mp="166ozj0vytu1v">
          <div className="overflow-hidden" data-id="element-1344" data-mp="22xkgttwvtomi">
            <motion.div className="flex" initial={{
            opacity: 1
          }} animate={{
            x: `-${currentIndex * 100}%`
          }} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} data-id="element-1345" data-mp="22wiuuuebvhq0">
              {products.map(product => <div key={product.id} className="min-w-full px-4" data-id="element-1346" data-mp="1jxwrt9z93gjg">
                  <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md flex flex-col md:flex-row" data-id="element-1347" data-mp="1ezlhky51n40p">
                    <div className="md:w-1/3 h-64 md:h-auto" data-id="element-1348" data-mp="1sz4q3s1rohdj">
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-1349" data-mp="1t0pgd5h1te5l" />
                    </div>
                    <div className="p-8 md:w-2/3" data-id="element-1350" data-mp="30cyazcp9myzi">
                      <div className="mb-2" data-id="element-1351" data-mp="30c6hq8j55dce">
                        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full uppercase font-semibold tracking-wide" data-id="element-1352" data-mp="37wh1e40u9ui4">
                          {product.category}
                        </span>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1353" data-mp="2xzuhbhgc77h5">
                        {product.name}
                      </h3>
                      <div className="flex items-center mb-4" data-id="element-1354" data-mp="3qmypfvaq81x5">
                        <div className="flex mr-2" data-id="element-1355" data-mp="3qnqndcrsqbql">
                          {renderStars(product.rating)}
                        </div>
                        <span className="text-gray-600 text-sm" data-id="element-1356" data-mp="3gx5ix8pfyczr">
                          {product.rating}/5
                        </span>
                      </div>
                      <p className="text-gray-700 mb-6 text-lg" data-id="element-1357" data-mp="3lufaatwe4yq8">
                        {product.review}
                      </p>
                      <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200" data-id="element-1358" data-mp="i6vijrrfuh9v">
                        Read Full Review
                      </button>
                    </div>
                  </div>
                </div>)}
            </motion.div>
          </div>
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md z-10 text-gray-800 hover:text-blue-600 transition-colors duration-200" aria-label="Previous product" data-id="element-1359" data-mp="j14i51o35cjk">
            <ChevronLeftIcon size={24} data-id="element-1360" data-mp="4crle2h6bpo0" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md z-10 text-gray-800 hover:text-blue-600 transition-colors duration-200" aria-label="Next product" data-id="element-1361" data-mp="3vjkya3lbxd8d">
            <ChevronRightIcon size={24} data-id="element-1362" data-mp="3hk33n7lcr5r3" />
          </button>
          <div className="flex justify-center mt-6" data-id="element-1363" data-mp="3hkl7oqe9ao9k">
            {products.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 w-2 rounded-full mx-1 ${currentIndex === index ? 'bg-blue-600' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1364" data-mp="1x1itpp6zn4in" data-mpi={index} />)}
          </div>
        </div>
      </div>
    </section>;
};